import { render } from "./QAndAChat.vue?vue&type=template&id=c53c7afe&scoped=true"
import script from "./QAndAChat.vue?vue&type=script&lang=js"
export * from "./QAndAChat.vue?vue&type=script&lang=js"

import "./QAndAChat.vue?vue&type=style&index=0&id=c53c7afe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c53c7afe"]])

export default __exports__